export default __webpack_public_path__ + "static/media/chong-nguoi-ta-16053546067770.ed2f186e.png";